export default __webpack_public_path__ + "static/media/skyship19.f96b618a.webp";